import { QueryClient } from "@tanstack/react-query";
import { useMyInfoStore } from "../lib/store/useMyInfoStore";
import type { Response } from "./dto/response/common.response";
import type { MyInfo } from "../types/auth.types";

export const AUTH_MY_INFO_QUERY_KEY = ["auth-my-info"] as const;

let client: QueryClient | null = null;

export function getQueryClient() {
  if (!client) {
    client = new QueryClient({
      defaultOptions: {
        queries: {
          retry: 1,
          refetchOnWindowFocus: false,
          staleTime: 0,
        },
      },
    });
  }
  return client;
}

/** 계정에 묶인 React Query 캐시를 전부 제거한다. */
export function resetSessionQueries() {
  getQueryClient().clear();
}

/** 로그아웃·토큰 실패처럼 세션이 끝날 때 유저 캐시(Query + Zustand)를 비운다. */
export function resetUserSession() {
  resetSessionQueries();
  useMyInfoStore.getState().clearMyInfo();
}

/** 로그인/가입 직후 홈이 이전 계정 캐시를 쓰지 않도록 my-info를 채워 둔다. */
export function seedMyInfoQuery(response: Response<MyInfo>) {
  getQueryClient().setQueryData(AUTH_MY_INFO_QUERY_KEY, response);
}
